<article class="asset-box">
    <div class="header">
        <mat-checkbox (change)="handleSelectionChange($event)" [checked]="uploadAsset.selected"></mat-checkbox>
        <button mat-icon-button (click)="removeFile()">
            <mat-icon fontIcon="close"></mat-icon>
        </button>
    </div>
    <div class="upload-preview">
        @if (isUploading()) {
            @if ((uploadAsset.progress || 0) < 100) {
                <mat-progress-bar mode="determinate" [value]="uploadAsset.progress"></mat-progress-bar>
            } @else {
                <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
            }
        } @else {
            <div class="image-wrapper">
                @if (hasImage && uploadAsset.thumbnail) {
                    <img [src]="uploadAsset.thumbnail" alt="" (error)="hasImage = false">
                } @else {
                    <div class="text-wrapper">
                        <span class="no-image">No image available</span>
                    </div>
                }
                @if (uploadAsset.fileExtension) {
                    <span class="icon"> {{ uploadAsset.fileExtension }}</span>
                }
            </div>
            <button [matTooltip]="uploadAsset.file ? uploadAsset.file.name : uploadAsset.assetBinary?.fileName" mat-raised-button class="upload-image-btn" (click)="fileInput.click()" style="width: 96%">
                @if (uploadAsset.file) {
                    {{ uploadAsset.file.name }}
                } @else {
                    {{ uploadAsset.assetBinary?.fileName }}
                }
            </button>
            <input #fileInput type="file" (change)="fileChanged($event)" [files]="files" style="display: none">
        }
    </div>
    <div class="properties" [formGroup]="propertiesForm">
        @for (prop of eligibleProperties; track prop.name) {
            @if (isPropertyVisible(prop)) {
                @if (prop.type === 'boolean') {
                    <div class="checkbox-wrapper">
                        <mat-checkbox [formControlName]="prop.name">
                            {{ 'property.' + prop.name|translate }}
                            @if (prop.hint) {
                                <mat-icon matTooltip="{{ prop.hint | translate }}" inline>info</mat-icon>
                            }
                        </mat-checkbox>
                    </div>
                } @else {
                    <mat-form-field>
                        <mat-label>
                            {{ 'property.' + prop.name|translate }}
                            @if (prop.hint) {
                                <mat-icon matTooltip="{{ prop.hint | translate }}">info</mat-icon>
                            }
                        </mat-label>
                        @if (prop.type === 'text') {
                            @if (prop.isMultiple) {
                                <mat-chip-grid #chipGrid
                                               [formControlName]="prop.name">
                                    @for (entry of getChipEntries(prop.name); track entry) {
                                        <mat-chip-row (removed)="removeChipEntry(prop.name, entry)">
                                            {{ entry }}
                                            <button matChipRemove>
                                                <mat-icon>cancel</mat-icon>
                                            </button>
                                        </mat-chip-row>
                                    }
                                </mat-chip-grid>
                                <input
                                        placeholder="{{ 'property.' + prop.name + '.placeholder'|translate }}"
                                        [matChipInputFor]="chipGrid"
                                        (matChipInputTokenEnd)="addChipEntry(prop, $event)"
                                        (blur)="handleBlur(prop.name, $event)"
                                />
                            } @else {
                                <input matInput [formControlName]="prop.name">
                            }
                        } @else if (prop.type === 'textarea') {
                            <textarea matInput [formControlName]="prop.name"></textarea>
                        } @else if (prop.type === 'checkbox') {
                            <mat-select [formControlName]="prop.name" multiple>
                                @for (option of prop.values; track option) {
                                    <mat-option [value]="option.value">
                                        {{ 'property.' + prop.name + '.' + option.value | translate }}
                                    </mat-option>
                                }
                            </mat-select>
                        }
                    </mat-form-field>
                }
            }
        }
    </div>
</article>
